<template>
  <div>
    <b-form-input
      v-model="searchQuery"
      class="d-inline-block mr-1"
      placeholder="Buscar..."
      style="width:90%"
    />
    <b-button
      v-if="USER().rol != ROLES.CLUB"
      v-b-tooltip.hover.v-primary
      v-b-modal.modal-nueva-noticia
      title="Nueva Petición"
      variant="flat-primary"
      class="btn-icon"
      @click="openTarea"
    >
      <feather-icon size="22" icon="PlusSquareIcon" />
    </b-button>
    <!-- <div>{{estado}}</div> -->
    <b-table
      ref="refInvoiceListTable"
      :fields="tableColumnsRender"
      :items="listFilter"
      primary-key="id"
      show-empty
      responsive
      small
      empty-text="No se encontraron datos"
      class="position-relative mt-2"
      style="max-height:60vh"
      :sticky-header="true"
      :no-border-collapse="false"
    >
      <template #cell(fecha_ingreso)="data">
        <small class="text-muted">{{ data.item.fecha_ingreso }}</small>
      </template>
      <!-- Column: Id -->

      <template #cell(nombre)="data">
        <b-media vertical-align="center">
          <span class="font-weight-bold d-block text-nowrap text-capitalize">
            {{ data.item.nombre }}
          </span>
          <small class="text-muted text-capitalize">{{
            data.item.solicitante
          }}</small>
        </b-media>
      </template>
      <template #cell(peticion)="data">
        <b-media vertical-align="center" style="word-wrap: break-word;">
          <span>
            {{ data.item.peticion }}
          </span>
        </b-media>
      </template>
      <template #cell(atendido_por)="data">
        <b-media vertical-align="center">
          <b-badge v-if="estado !== 0" pill :variant="data.item.color">
            {{ data.item.atendido_por }} <br />
            <span style="font-size:10px">{{
              data.item.id_estado === '2'
                ? data.item.fecha_entra_revision
                : data.item.id_estado === '3'
                ? data.item.fecha_respuesta
                : ''
            }}</span>
          </b-badge>
          <span
            v-else
            class="font-weight-bold d-block text-nowrap text-capitalize"
          >
            {{ data.item.atendido_por }}
          </span>
        </b-media>
      </template>
      <template #cell(estado)="data">
        <b-badge v-if="estado === 0" pill :variant="data.item.color">
          {{ data.item.estado }} <br />
          <span style="font-size:10px">{{
            data.item.id_estado === '2'
              ? data.item.fecha_entra_revision
              : data.item.id_estado === '3'
              ? data.item.fecha_respuesta
              : ''
          }}</span>
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(accion)="data">
        <div class="text-nowrap">
          <feather-icon
            :id="`invoice-row-${data.item.id}-send-icon`"
            icon="EditIcon"
            class="cursor-pointer"
            size="16"
            @click="updateTarea(data.item)"
          />
          <feather-icon
            v-if="data.item.id_estado === '1'"
            icon="TrashIcon"
            class="cursor-pointer mx-1"
            size="16"
            @click="deleteTarea(data.item)"
          />
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import { computed, ref } from '@vue/composition-api'
import {
  BTable,
  BFormInput,
  BMedia,
  BBadge,
  BButton,
  VBTooltip,
  //   xx,
  //   xx,
  //   xxx,
  //   xxxx,
} from 'bootstrap-vue'
import {
  USER,
  ROLES,
  // xx
} from '../../utils/variables'

export default {
  components: {
    BTable,
    BFormInput,
    BMedia,
    BBadge,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    listPeticiones: Array,
    estado: Number,
  },
  setup(props, { emit }) {
    const searchQuery = ref('')
    const tableColumns1 = [
      { key: 'id_peticion', label: 'ID', sortable: true },
      { key: 'fecha_ingreso', label: 'F/Reg', sortable: true },
      { key: 'nombre', sortable: true },
      { key: 'peticion', sortable: true },
      { key: 'accion' },
    ]
    const tableColumns2 = [
      { key: 'id_peticion', label: 'ID', sortable: true },
      { key: 'fecha_ingreso', label: 'F/Reg', sortable: true },
      { key: 'nombre', sortable: true },
      { key: 'peticion', sortable: true },
      { key: 'atendido_por', label: 'Soporte', sortable: true },
      { key: 'accion' },
    ]
    const tableColumns3 = [
      { key: 'id_peticion', label: 'ID', sortable: true },
      { key: 'fecha_ingreso', label: 'F/Reg', sortable: true },
      { key: 'nombre', sortable: true },
      { key: 'peticion', sortable: true },
      { key: 'atendido_por', label: 'Soporte', sortable: true },
      { key: 'accion' },
    ]
    const tableColumns4 = [
      { key: 'id_peticion', label: 'ID', sortable: true },
      { key: 'fecha_ingreso', label: 'F/Reg', sortable: true },
      { key: 'nombre', sortable: true },
      { key: 'peticion', sortable: true },
      { key: 'atendido_por', label: 'Soporte', sortable: true },
      { key: 'accion' },
    ]
    const tableColumns0 = [
      { key: 'id_peticion', label: 'ID', sortable: true },
      { key: 'fecha_ingreso', label: 'F/Reg', sortable: true },
      { key: 'nombre', sortable: true },
      { key: 'peticion', sortable: true },
      { key: 'atendido_por', label: 'Soporte', sortable: true },
      { key: 'estado', label: 'Soporte', sortable: true },
      { key: 'accion' },
    ]

    const tableColumnsRender = computed(() => {
      if (props.estado === 1) {
        return tableColumns1
      }
      if (props.estado === 2) {
        return tableColumns2
      }
      if (props.estado === 3) {
        return tableColumns3
      }
      if (props.estado === 4) {
        return tableColumns4
      }
      if (props.estado === 0) {
        return tableColumns0
      }
      return tableColumns1
    })
    const listFilter = computed(
      () =>
        // eslint-disable-next-line
        props.listPeticiones.filter(
          player =>
            // eslint-disable-next-line
            player.nombre
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase())
          // eslint-disable-next-line
        )
      // eslint-disable-next-line
    )
    // function showModal() {
    //   console.log('sds')
    // }
    function openTarea() {
      // console.log('opennn')
      emit('openTarea')
    }
    function updateTarea(item) {
      emit('updateTarea', item)
    }
    function deleteTarea(item) {
      emit('deleteTarea', item)
    }
    return {
      // tableColumns,
      listFilter,
      searchQuery,
      openTarea,
      updateTarea,
      tableColumnsRender,
      deleteTarea,
      USER,
      ROLES,
    }
  },
}
</script>
